import React from "react";
import "./Card.css";
import { useNavigate } from "react-router-dom";

const Card = (props) => {
  return <CompactCard param={props} />;
};

function CompactCard({ param }) {
  const totalCount = param.series[0]?.data.reduce((sum, num) => sum + num, 0) || 0;
  const navigate = useNavigate();

  const handleViewClick = (e) => {
    e.stopPropagation(); // Prevent card click
    navigate("/download-orders");
  };

  return (
    <div
      className="CompactCard"
      style={{
        background: param.color.backGround,
        boxShadow: param.color.boxShadow,
        cursor: param.title === "Total Orders" ? "pointer" : "default",
      }}
    >
      <div className="cardContent">
        <div className="cardText">
          <span className="cardTitle">{param.title}</span>
          <h2 className="cardValue">{totalCount}</h2>
        </div>

        {param.title === "Total Orders" && (
          <button className="viewButton" onClick={handleViewClick}>
            View
          </button>
        )}
      </div>
    </div>
  );
}

export default Card;
